import React from "react";
import SageShimmer from "kit/SageShimmer";
import classnames from "classnames";
import styles from "./SageShimmerListItem.module.scss";

const SageShimmerListItem: React.FC = () => {
    return (
        <div
            className={classnames(
                "list-group-item",
                "list-group-item-action",
                "disabled"
            )}
        >
            <div className={styles.container}>
                <SageShimmer className={classnames(styles.loading)} />
            </div>
        </div>
    );
};

export default SageShimmerListItem;
